import { create } from 'zustand';

interface FloatingChatState {
  blipChatOpen: boolean;
  setBlipChatOpen: (open: boolean) => void;
}

export const useFloatingChat = create<FloatingChatState>((set) => ({
  blipChatOpen: false,
  setBlipChatOpen: (open) => set({ blipChatOpen: open }),
}));
